// extracted by mini-css-extract-plugin
export default {"wrapper":"k4-z","play":"l4-z"};